module.exports = __webpack_public_path__ + "static/media/Satoshi_Medium.cd790237.woff2";